import Vue from "vue";
import { ToastPlugin, ModalPlugin, BootstrapVue } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";

import router from "./router";
import store from "./store";
import App from "./App.vue";

// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/toastification";

import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCsvxB_NdcAEeYRvqWLx0OebjTpgRgGA5Q",
  authDomain: "citizen-drohobych.firebaseapp.com",
  projectId: "citizen-drohobych",
  storageBucket: "citizen-drohobych.appspot.com",
  messagingSenderId: "95979744128",
  appId: "1:95979744128:web:70ffc757baeb36e2a7ef65",
  measurementId: "G-ZP93FR9E2W",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//Firebase Auth services
import auth from "./providers/auth";
Vue.prototype.$auth = auth(app);

//Firebase Auth services
import db from "./providers/db";
Vue.prototype.$db = db(app);

//AXIOS as API
import api from "./providers/api";
Vue.prototype.$api = api.axiosApi;
Vue.prototype.$fileApi = api.fileApi;

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(BootstrapVue);

// Composition API
Vue.use(VueCompositionAPI);

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

//////////////////////////////
// ACL - managing user roles
//////////////////////////
import acl from "./acl/acl";

Vue.config.productionTip = false;

new Vue({
  // acl,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
